(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smoke-gone-experience"] && !Shopify.designMode) return;
  try {
    (() => {
 const boot = () => {
 const nav = document.querySelector('.sg-scene-nav');
 if (!nav || nav.dataset.ready) return;
 nav.dataset.ready = 'true';
 const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
 const choices = [
 ['.sg-ref-intro, .sg-hero', 'Welcome'],
 ['.sg-ref-360-slot .sg360, .sg360', 'Explore the bottle'],
 ['.sg-ref-shop, .sg-pricing', 'Choose your pack'],
 ['.sg-ref-motion-slot .sgm, .sgm', 'How it works'],
 ['.sg-home .sg-split', 'How to use'],
 ['.sg-home .sg-faq', 'Questions']
 ];
 const seen = new Set();
 const scenes = [];
 choices.forEach(([selector,label],i) => {
 const el = [...document.querySelectorAll(selector)].find(x => x.getClientRects().length && getComputedStyle(x).visibility !== 'hidden');
 if (!el || seen.has(el)) return;
 seen.add(el);
 el.id = el.id || 'sg-scene-' + i;
 el.classList.add('sg-scene');
 const a = document.createElement('a');
 a.href = '#' + el.id;
 a.setAttribute('aria-label',label);
 const text = document.createElement('span'); text.textContent = label; a.append(text);
 a.addEventListener('click', e => {
 e.preventDefault();
 el.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'});
 });
 nav.append(a);
 scenes.push({el,a});
 });
 nav.hidden = scenes.length < 2;
 if (!('IntersectionObserver' in window)) return;
 const observer = new IntersectionObserver(entries => {
 entries.forEach(entry => {
 if (!entry.isIntersecting) return;
 const scene = scenes.find(x => x.el === entry.target);
 if (!scene) return;
 scenes.forEach(x => x.a.removeAttribute('aria-current'));
 scene.a.setAttribute('aria-current','location');
 if (!reduced && !entry.target.dataset.sgRevealed) {
 entry.target.dataset.sgRevealed = 'true';
 entry.target.classList.add('sg-scene-enter');
 entry.target.addEventListener('animationend',()=>entry.target.classList.remove('sg-scene-enter'),{once:true});
 }
 });
 },{rootMargin:'-15% 0px -30% 0px',threshold:0});
 scenes.forEach(x=>observer.observe(x.el));
 };
 if(document.readyState==='complete') boot();
 else window.addEventListener('load',boot,{once:true});
 document.addEventListener('shopify:section:load',()=>{const nav=document.querySelector('.sg-scene-nav');if(nav){nav.replaceChildren();delete nav.dataset.ready;}boot();});
})();
  } catch(e) { console.error(e); }
})();

})();
